import { IncidentReportDetailModalContext } from '@/contexts'
import { useContext } from 'react'

export const useIncidentReportDetailModalContext = () => {
  const context = useContext(IncidentReportDetailModalContext)

  if (!context) throw new Error('useIncidentReportDetailModalContext has to be wrapped IncidentReportDetailModalContextProvider')
  
  return context
}
